document.addEventListener("DOMContentLoaded", function () {
  // Collapsible functionality
  const collapsibleHeaders = document.querySelectorAll(".collapsible-header");

  // Function to toggle collapsible content
  function toggleCollapsible(header) {
    // Find the parent collapsible element
    const collapsible = header.closest(".collapsible");

    // Toggle the active class
    if (collapsible) {
      collapsible.classList.toggle("active");

      // Animate content height
      const content = collapsible.querySelector(".content");
      if (content) {
        if (collapsible.classList.contains("active")) {
          content.style.maxHeight = content.scrollHeight + "px";
          // Remove the maxHeight after 1 second to allow dynamic content height
          setTimeout(() => {
            if (collapsible.classList.contains("active")) {
              content.style.maxHeight = "none";
            }
          }, 1000);
        } else {
          content.style.maxHeight = "0";
        }
      }
    }
  }

  // Add click event listener to each header
  collapsibleHeaders.forEach((header) => {
    // Handle mouse clicks
    header.addEventListener("click", function() {
      toggleCollapsible(this);
    });
    
    // Handle keyboard Enter key presses
    header.addEventListener("keydown", function(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        toggleCollapsible(this);
      }
    });
  });

  // Initialize content heights
  document.querySelectorAll(".collapsible").forEach((collapsible) => {
    const content = collapsible.querySelector(".content");
    if (content) {
      if (collapsible.classList.contains("active")) {
        content.style.maxHeight = content.scrollHeight + "px";
        setTimeout(() => {
          if (collapsible.classList.contains("active")) {
            content.style.maxHeight = "none";
          }
        }, 1000);
      } else {
        content.style.maxHeight = "0";
      }
    }
  });
  // Gift Box Variant ID — single source of truth for this whole file.
  const GIFT_BOX_VARIANT_ID = 50840309498157;
  const CART_PATH = "/cart";

  // Function to handle toggle button activation and set focus to first form element
  function toggleButtonAndFocus(toggleBtn, containerId) {
    if (!toggleBtn || !containerId) return;
    
    const container = document.getElementById(containerId);
    if (!container) return;
    
    // Toggle container and button state
    const isActive = toggleBtn.classList.contains('active');
    container.classList.toggle("show");
    toggleBtn.classList.toggle("active");
    
    // If the button was just activated (not deactivated), focus on the first form element
    if (!isActive && toggleBtn.classList.contains('active')) {
      setTimeout(() => {
        // Find the first focusable form element
        const firstInput = container.querySelector('input, select, textarea, button, [href], [tabindex]:not([tabindex="-1"])');
        if (firstInput) {
          firstInput.focus();
        }
      }, 100);
    }
  }
  
  // Gift button toggle functionality
  const giftBtn = document.getElementById("gift-btn");
  if (giftBtn) {
    // Click handler
    giftBtn.addEventListener("click", function() {
      toggleButtonAndFocus(this, "giftbox_container");
    });
    
    // Enter key handler
    giftBtn.addEventListener("keydown", function(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        toggleButtonAndFocus(this, "giftbox_container");
      }
    });
  }

  // Handle checkbox limitation (max 4)
  const checkboxes = document.querySelectorAll(
    ".gift-select-row input[type=checkbox]"
  );
  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function (e) {
      const checkedBoxes = document.querySelectorAll(
        ".gift-select-row input[type=checkbox]:checked"
      );
      const errorElement = document.querySelector("#giftbox_container .error");

      if (checkedBoxes.length > 4) {
        this.checked = false;
        if (errorElement) {
          errorElement.innerHTML = "Please select upto 4 products per box";
          errorElement.style.display = "block";
        }
      } else if (errorElement) {
        errorElement.innerHTML = "";
        errorElement.style.display = "none";
      }
    });
  });

  // Discard button functionality
  const discardBtn = document.getElementById("discard-btn");
  if (discardBtn) {
    discardBtn.addEventListener("click", function (e) {
      e.preventDefault();
      document.getElementById("gift-btn").click();
      document.getElementById("gift-form").reset();
    });
  }

  // Save button functionality to add gift box product with selected products as properties
  const saveBtn = document.getElementById("save-btn");
  if (saveBtn) {
    saveBtn.addEventListener("click", function (e) {
      e.preventDefault();

      // Get all checked gift items
      const selectedItems = document.querySelectorAll(
        ".gift-select-row input[type=checkbox]:checked"
      );

      if (selectedItems.length === 0) {
        const errorElement = document.querySelector(
          "#giftbox_container .error"
        );
        if (errorElement) {
          errorElement.innerHTML =
            "Please select at least one product to gift wrap";
          errorElement.style.display = "block";
        }
        return;
      }

      // Get gift message details (defensive — fields may not be on every cart template)
      const valueOf = (id) => {
        const el = document.getElementById(id);
        return el ? el.value : "";
      };
      const to = valueOf("same_to");
      const from = valueOf("same_from");
      const message = valueOf("same_message");
      const label = valueOf("same_label");

      // Create properties object for the gift box product
      const properties = {};

      // Add gift message details as properties
      if (to) properties["To"] = to;
      if (from) properties["From"] = from;
      if (message) properties["Message"] = message;
      if (label) properties["Box Label"] = label;

      // Add selected products as properties
      selectedItems.forEach((item, index) => {
        properties[`Product ${index + 1}`] = item.value;
      });

      // Set loading state
      saveBtn.disabled = true;
      saveBtn.textContent = "Adding...";

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: GIFT_BOX_VARIANT_ID,
          quantity: 1,
          properties: properties,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Gift box added:", data);

          // Reset button state
          saveBtn.disabled = false;
          saveBtn.textContent = "ADD GIFT BOX TO BAG";

          // Set the gift_add hidden field to 1 (active)
          const giftAdd = document.getElementById("gift_add");
          if (giftAdd) giftAdd.value = "1";

          // Close the gift box container
          const giftBtnEl = document.getElementById("gift-btn");
          if (giftBtnEl) giftBtnEl.click();

          // If we're on the cart page, hard refresh; otherwise re-render the drawer in place.
          if (window.location.pathname === CART_PATH) {
            window.location.href = CART_PATH;
          } else if (typeof refreshCartDrawerSections === "function") {
            refreshCartDrawerSections();
          }
        })
        .catch((error) => {
          console.error("Error adding gift box to cart:", error);

          // Reset button state
          saveBtn.disabled = false;
          saveBtn.textContent = "ADD GIFT BOX TO BAG";

          // Show error message
          const errorElement = document.querySelector(
            "#giftbox_container .error"
          );
          if (errorElement) {
            errorElement.innerHTML =
              "There was an error adding the gift box. Please try again.";
            errorElement.style.display = "block";
          }
        });
    });
  }
  // ====== CART CHANGE MONITORING ======
  // Define DEBUG mode - set to false in production
  const DEBUG = false;

  // Improved logging function that only outputs when DEBUG is true
  function log(...args) {
    if (DEBUG) {
      console.log(...args);
    }
  }

  // Function to handle errors with optional logging
  function handleError(message, error) {
    // Always log errors to console
    console.error(message, error);
    return error;
  }

  // The active operation tracker prevents race conditions
  let isProcessingCart = false;

  // Refresh the cart drawer / cart icon by re-fetching the rendered section HTML.
  // Used after add-to-cart to catch silent updates from third-party apps
  // (e.g. Regios free-gift injection) so the drawer reflects them without
  // a full page reload. Does NOT open/close the drawer.
  function refreshCartDrawerSections() {
    return fetch("/?sections=mini-cart,cart-icon-bubble,mobile-cart-icon-bubble", {
      credentials: "same-origin"
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((sections) => {
        if (!sections) return;
        const apply = (id, html) => {
          const el = document.getElementById(id);
          if (!el || !html) return;
          const parsed = new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(".shopify-section");
          if (parsed) el.innerHTML = parsed.innerHTML;
        };
        apply("mini-cart", sections["mini-cart"]);
        apply("cart-icon-bubble", sections["cart-icon-bubble"]);
        apply("mobile-cart-icon-bubble", sections["mobile-cart-icon-bubble"]);
      })
      .catch(() => {});
  }

  // Function to remove gift box when associated product is removed
  function removeGiftBox(key) {
    log("Removing gift box with key:", key);

    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Cart update failed: ${response.status}`);
        }
        return response.json();
      })
      .then((cart) => {
        log("Gift box removed successfully");
        return cart;
      })
      .catch((error) => handleError("Error removing gift box:", error));
  }

  // Extract product identifiers from cart items for more efficient comparison
  function getProductIdentifiers(cartItems) {
    // Create a map for faster lookups
    const productMap = {};

    cartItems.forEach((item) => {
      if (item.variant_id !== GIFT_BOX_VARIANT_ID) {
        const identifier = `${item.product_title} (${item.sku})`;
        productMap[identifier] = true;
      }
    });

    return productMap;
  }

  // Function to check if all products referenced in gift boxes are still in cart
  function checkGiftBoxProducts() {
    // Avoid simultaneous operations
    if (isProcessingCart) {
      log("Already processing cart, skipping check");
      return Promise.resolve(false);
    }

    isProcessingCart = true;
    log("Checking if gift box products are still in cart...");

    return fetch("/cart.js")
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch cart: ${response.status}`);
        }
        return response.json();
      })
      .then((cart) => {
        // Quick check if there are any gift boxes
        const giftBoxes = cart.items.filter(
          (item) => item.variant_id === GIFT_BOX_VARIANT_ID
        );
        if (giftBoxes.length === 0) {
          log("No gift boxes in cart");
          isProcessingCart = false;
          return false;
        }

        // Get all regular product identifiers in cart (more efficient using a map)
        const availableProductMap = getProductIdentifiers(cart.items);
        log(
          "Available products in cart:",
          Object.keys(availableProductMap).length
        );

        // Track gift boxes to remove
        const boxesToRemove = [];

        // For each gift box, check if all referenced products are still in cart
        giftBoxes.forEach((giftBox) => {
          // Extract product references from properties
          const referencedProducts = [];
          for (let i = 1; i <= 4; i++) {
            const propKey = `Product ${i}`;
            if (giftBox.properties && giftBox.properties[propKey]) {
              referencedProducts.push(giftBox.properties[propKey]);
            }
          }

          if (referencedProducts.length === 0) {
            log(
              "Gift box has no referenced products, will remove:",
              giftBox.key
            );
            boxesToRemove.push(giftBox.key);
            return;
          }

          // Check if any referenced product is missing from the cart
          const missingProducts = referencedProducts.filter(
            (productRef) => !availableProductMap[productRef]
          );

          if (missingProducts.length > 0) {
            log("Products missing from gift box, will remove:", giftBox.key);
            boxesToRemove.push(giftBox.key);
          }
        });

        // If no boxes need to be removed, we're done
        if (boxesToRemove.length === 0) {
          log("All gift boxes have valid products");
          isProcessingCart = false;
          return false;
        }

        // Remove gift boxes sequentially to avoid race conditions
        return boxesToRemove
          .reduce((promise, boxKey) => {
            return promise.then(() => removeGiftBox(boxKey));
          }, Promise.resolve())
          .then(() => {
            log("All gift boxes processed");
            isProcessingCart = false;
            return true; // Signal that we made changes
          });
      })
      .catch((error) => {
        handleError("Error checking gift boxes:", error);
        isProcessingCart = false;
        return false;
      });
  }

  // More efficient debounce function
  function debounce(func, wait) {
    let timeout;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  // Debounced version of checkGiftBoxProducts
  const debouncedCheckGiftBoxes = debounce(() => {
    checkGiftBoxProducts().then((changesDetected) => {
      if (!changesDetected) return;
      // Only hard-reload when the user is on the cart page (they need to see the
      // line item disappear). On every other page just re-render the drawer in
      // place so we don't disrupt the user's session.
      if (window.location.pathname === CART_PATH) {
        log("Gift box reconciled on cart page — reloading");
        setTimeout(() => window.location.reload(), 300);
      } else {
        log("Gift box reconciled off cart — refreshing drawer in place");
        refreshCartDrawerSections();
      }
    });
  }, 500);

  // Set up mutation observer to watch for cart changes - more targeted for efficiency
  const cartObserver = new MutationObserver(function (mutations) {
    // More efficient check for cart changes
    for (let i = 0; i < mutations.length; i++) {
      const mutation = mutations[i];
      const target = mutation.target;

      // Look for cart item changes (broader search to catch various themes)
      if (
        mutation.type === "childList" ||
        (mutation.type === "attributes" &&
          ((target.classList && target.classList.contains("cart-item")) ||
            (target.closest && target.closest('[class*="cart"]')) ||
            (target.closest && target.closest('[id*="cart"]'))))
      ) {
        log("Cart DOM change detected");
        debouncedCheckGiftBoxes();
        break;
      }
    }
  });

  // More robust cart container detection
  function findCartContainer() {
    const possibleSelectors = [
      ".cart__items-wrapper",
      ".cart__items",
      ".cart-items",
      ".cart-item-list",
      "#cart-items",
      "[data-cart-items]",
      ".cart__drawer-items",
      // Add more theme-specific selectors if needed
      ".cart", // Fallback - wider target
    ];

    for (let selector of possibleSelectors) {
      const container = document.querySelector(selector);
      if (container) return container;
    }

    // Final fallback - try to find anything cart related
    return (
      document.querySelector('[class*="cart"]') ||
      document.querySelector('[id*="cart"]')
    );
  }

  // Start observing cart container - with bounded retry for async loaded carts.
  // Capped so pages without a cart (password page, error page) don't poll forever.
  const CART_OBSERVER_MAX_RETRIES = 30; // 30 attempts × 1s = 30s
  let cartObserverRetries = 0;
  function startCartObserver() {
    const cartContainer = findCartContainer();

    if (cartContainer) {
      log("Cart container found, starting observer");
      cartObserver.observe(cartContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "style"],
      });
      return;
    }

    cartObserverRetries++;
    if (cartObserverRetries >= CART_OBSERVER_MAX_RETRIES) {
      log("Cart container not found after max retries — giving up");
      return;
    }
    // Retry in case cart loads dynamically
    log("Cart container not found, will retry", cartObserverRetries);
    setTimeout(startCartObserver, 1000);
  }

  // Debounced section refresh — collapses rapid add bursts (theme + app injections)
  // into a single re-render.
  const debouncedRefreshCartDrawer = debounce(refreshCartDrawerSections, 600);

  // Listen to common cart update events
  function setupEventListeners() {
    // Standard Shopify cart event
    document.addEventListener("cart:updated", debouncedCheckGiftBoxes);
    document.addEventListener("cart:refresh", debouncedCheckGiftBoxes);

    // Ajax API calls interceptor - more robust implementation.
    // Only watch operations that can REMOVE items (change/update/clear). /cart/add
    // can never invalidate a gift box (adding products doesn't remove referenced ones),
    // and running the check after every add was causing unrelated flows (like the
    // SkinMatch quiz routine add) to trigger a page reload after a few seconds.
    //
    // For /cart/add we instead schedule a deferred re-render of the cart drawer
    // to catch silent gift adds from apps like Regios. No reload, just a section swap.
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      const fetchCall = originalFetch.apply(this, args);

      try {
        const url = args[0] && args[0].url ? args[0].url : args[0];

        if (
          typeof url === "string" &&
          (url.includes("/cart/change") ||
            url.includes("/cart/update") ||
            url.includes("/cart/clear"))
        ) {
          log("Cart fetch detected");
          fetchCall
            .then(() => setTimeout(debouncedCheckGiftBoxes, 300))
            .catch(() => {}); // Ignore errors in the monitoring chain
        } else if (
          typeof url === "string" &&
          url.includes("/cart/add")
        ) {
          // Wait long enough for Regios (or any other app) to inject its
          // companion line item, then re-render the drawer in place.
          // Debounced so a burst of adds → single refresh.
          fetchCall
            .then(() => setTimeout(debouncedRefreshCartDrawer, 1500))
            .catch(() => {});
        }
      } catch (e) {
        // Don't let our monitoring code break fetch
        handleError("Error in fetch monitoring:", e);
      }

      return fetchCall;
    };

    // Also intercept XMLHttpRequest for older implementations
    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      try {
        if (
          typeof url === "string" &&
          (url.includes("/cart/change") ||
            url.includes("/cart/update") ||
            url.includes("/cart/clear"))
        ) {
          log("XMLHttpRequest to cart detected");
          const originalOnReadyStateChange = this.onreadystatechange;
          this.onreadystatechange = function () {
            if (this.readyState === 4) {
              setTimeout(debouncedCheckGiftBoxes, 300);
            }
            if (originalOnReadyStateChange) {
              originalOnReadyStateChange.apply(this, arguments);
            }
          };
        }
      } catch (e) {
        // Don't let our monitoring break XHR
        handleError("Error in XHR monitoring:", e);
      }

      return originalOpen.apply(this, [method, url, ...rest]);
    };

    // Handle form submissions for traditional cart forms
    document.addEventListener("submit", function (e) {
      if (
        e.target &&
        e.target.action &&
        (e.target.action.includes("/cart/add") ||
          e.target.action.includes("/cart"))
      ) {
        log("Cart form submission detected");
        setTimeout(debouncedCheckGiftBoxes, 1000);
      }
    });

    // Listen for click events on remove buttons
    document.addEventListener("click", function (e) {
      const target = e.target;
      if (
        target &&
        (target.matches('[href*="/cart/change"]') ||
          (target.closest && target.closest('[href*="/cart/change"]')) ||
          target.matches("[data-cart-remove]") ||
          (target.closest && target.closest("[data-cart-remove]")))
      ) {
        log("Cart remove button clicked");
        setTimeout(debouncedCheckGiftBoxes, 500);
      }
    });
  }

  // Initialize everything
  function initGiftBoxMonitoring() {
    log("Initializing gift box monitoring");
    setupEventListeners();
    startCartObserver();

    // Initial check after page load
    setTimeout(debouncedCheckGiftBoxes, 1000);
  }

  // Start the monitoring
  initGiftBoxMonitoring();

  // Gift card button toggle functionality
  const gcBtn = document.getElementById("gc_btn");
  if (gcBtn) {
    // Click handler
    gcBtn.addEventListener("click", function() {
      toggleButtonAndFocus(this, "gc_container");
    });
    
    // Enter key handler
    gcBtn.addEventListener("keydown", function(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        toggleButtonAndFocus(this, "gc_container");
      }
    });
  }

  // Giftcard Discard button functionality
  const discardGcBtn = document.getElementById("discard-gc-btn");
  if (discardGcBtn) {
    discardGcBtn.addEventListener("click", function (e) {
      e.preventDefault();
      document.getElementById("gc_btn").click();
      document.getElementById("gift-card-form").reset();
    });
  }

  // Membership button toggle functionality
  const membershipBtn = document.getElementById("membership_btn");
  if (membershipBtn) {
    // Click handler
    membershipBtn.addEventListener("click", function() {
      toggleButtonAndFocus(this, "membership_container");
    });
    
    // Enter key handler
    membershipBtn.addEventListener("keydown", function(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        toggleButtonAndFocus(this, "membership_container");
      }
    });
  }

  // Membership Discard button functionality
  const discardMembershipBtn = document.getElementById(
    "discard-membership-btn"
  );
  if (discardMembershipBtn) {
    discardMembershipBtn.addEventListener("click", function (e) {
      e.preventDefault();
      document.getElementById("membership_btn").click();
      document.getElementById("membership-form").reset();
    });
  }
});
